<script setup lang="ts">
import type { CheckboxValueType } from 'element-plus';

import { ref } from 'vue';

import { useVbenModal } from '@vben/common-ui';

import {
  ElButton,
  ElCheckbox,
  ElCheckboxGroup,
  ElLink,
  ElMessage,
} from 'element-plus';

import { setOrderLabelApi } from '#/api';
import LabelItem from '#/components/order/Label/Item.vue';
import { useDicEnumStore } from '#/store';

const dicEnumStore = useDicEnumStore();
const labelTypeList = dicEnumStore.dicEnum?.label_type.filter(
  (item) => item.type >= 0,
);
const unsetLabel = ref<boolean>(true);
const labelIds = ref<string[]>([]);
const [Modal, modalApi] = useVbenModal({
  header: false,
  footer: false,
  fullscreenButton: false,
  closable: false,
  class: 'w-80',
  onOpenChange: (isOpen: boolean) => {
    if (isOpen) {
      const data = modalApi.getData<Record<string, any>>();
      labelIds.value = data.labelIds || [];
      unsetLabel.value = !data.labelIds || data.labelIds.length === 0;
    }
  },
});

function onCancel() {
  modalApi.close();
}

function onAll() {
  labelIds.value = labelTypeList.map((item) => item.type);
  unsetLabel.value = false;
}

function onInvert() {
  labelIds.value =
    labelIds.value.length > 0
      ? labelTypeList
          .filter((item) => !labelIds.value.includes(item.type))
          .map((item) => item.type)
      : labelTypeList.map((item) => item.type);
  unsetLabel.value = labelIds.value.length === 0;
}

function onChangeColor(value: CheckboxValueType[] | string[]): void {
  unsetLabel.value = value.length === 0;
}

// 保存
async function save() {
  const { orderIds } = modalApi.getData<Record<string, any>>();
  await setOrderLabelApi({
    orderIds,
    labelIds: labelIds.value,
  });
  ElMessage.success('保存成功');
  modalApi
    .setData({
      refresh: true,
    })
    .close();
}
</script>
<template>
  <Modal>
    <div class="flex flex-wrap items-center justify-between">
      <h2>选择颜色标签</h2>
      <div>
        <ElLink style="margin-right: 0" :underline="false" @click="onAll">
          全选
        </ElLink>
        <ElLink
          class="ml-2"
          style="margin-right: 0"
          :underline="false"
          @click="onInvert"
        >
          反选
        </ElLink>
      </div>
    </div>

    <ElCheckboxGroup class="mt-4" v-model="labelIds" @change="onChangeColor">
      <div class="flex flex-wrap">
        <div
          class="w-1/2"
          v-for="labelType in labelTypeList"
          :key="labelType.type"
        >
          <ElCheckbox :value="labelType.type">
            <LabelItem class="w-[24px]" :type="labelType.type" />
          </ElCheckbox>
        </div>
      </div>
    </ElCheckboxGroup>
    <div class="mb-2 mt-6 flex justify-center">
      <ElButton @click="onCancel"> 取消</ElButton>
      <ElButton @click="save" type="primary"> 确认保存</ElButton>
    </div>
  </Modal>
</template>
